// AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};


export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("authToken") || null);


  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "authToken" && event.newValue === null) {
        setToken(null);
      }

      if(event.key === "authToken" && event.newValue !== null) {
        setToken(event.newValue);
        localStorage.setItem("authToken", event.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const login = (authToken) => {
    setToken(authToken);
    localStorage.setItem("authToken", authToken);
  };

  const logout = () => {
    setToken(null);
    localStorage.removeItem("authToken");
    localStorage.clear();
  };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
